import { Box } from "@mui/material";
import FormOptionCard, { FormOptionCardConfig } from "app/components/FormOptionCard";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectQuotationLocks } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { AddOnItemFormValue, QuotationLocksState } from "../../../types";
import { useStyles as useAddOnStyles } from "../AddOn/styles";
import { QUOTATION_FORM_I18N_PREFIX } from "../data";
import { FormSection } from "../VehicleDetails/FormControls";
import { useStyles } from "./styles";

type CardKey = keyof QuotationLocksState;
const P = `${QUOTATION_FORM_I18N_PREFIX}.LOCKS`;
const tKey = (suffix: string) => `${P}.${suffix}`;

const LOCK_CARDS: Record<CardKey, FormOptionCardConfig> = {
  dieselLock: {
    titleKey: tKey("CARDS.DIESEL_LOCK"), fields: ["note"], notePlaceholderKey: tKey("FIELDS.NOTE"),
  },
  ureaLock: {
    titleKey: tKey("CARDS.UREA_LOCK"), fields: ["note"], notePlaceholderKey: tKey("FIELDS.NOTE"),
  },
  batteriesLock: {
    titleKey: tKey("CARDS.BATTERIES_LOCK"), fields: ["note"], notePlaceholderKey: tKey("FIELDS.NOTE"),
  },
  hydraulicTailLiftMotorLock: {
    titleKey: tKey("CARDS.HYDRAULIC_TAIL_LIFT_MOTOR_LOCK"), fields: ["note"],
    notePlaceholderKey: tKey("FIELDS.NOTE"),
  },
  hydraulicTailLiftLock: {
    titleKey: tKey("CARDS.HYDRAULIC_TAIL_LIFT_LOCK"), fields: ["radio"],
    radioLabelKey: tKey("FIELDS.TYPE"),
    radioOptions: [
      { value: "HASP", labelKey: tKey("OPTIONS.HASP") },
      { value: "EYELET", labelKey: tKey("OPTIONS.EYELET") },
    ],
  },
  spareWheelLock: {
    titleKey: tKey("CARDS.SPARE_WHEEL_LOCK"), fields: ["note"], notePlaceholderKey: tKey("FIELDS.NOTE"),
  },
};

const LocksPanel = () => {
  const dispatch = useDispatch();
  const locks = useSelector(selectQuotationLocks);
  const styles = useStyles();
  const addOnStyles = useAddOnStyles();
  if (!locks) return null;

  const labels = {
    note: tKey("FIELDS.NOTE"), quantity: tKey("FIELDS.NOTE"),
    size: tKey("FIELDS.NOTE"), location: tKey("FIELDS.NOTE"), itemType: tKey("FIELDS.TYPE"),
  };
  const update = (key: CardKey, value: Partial<AddOnItemFormValue>) =>
    dispatch(actions.updateQuotationLocks({ key, value }));
  const renderCard = (key: CardKey) => (
    <FormOptionCard key={key} config={LOCK_CARDS[key]} value={locks[key]} labels={labels}
      onChange={(v) => update(key, v)} />
  );

  return (
    <FormSection titleKey={tKey("SECTIONS.LOCKS")} titleClassName={styles.sectionTitle}>
      <Box className={addOnStyles.sectionContent}>
        <Box className={styles.tyingGrid4}>
          {renderCard("dieselLock")}
          {renderCard("ureaLock")}
          {renderCard("batteriesLock")}
          {renderCard("hydraulicTailLiftMotorLock")}
        </Box>
        <Box className={`${addOnStyles.cardRow} ${addOnStyles.cardRow2}`}>
          {renderCard("hydraulicTailLiftLock")}
          {renderCard("spareWheelLock")}
        </Box>
      </Box>
    </FormSection>
  );
};

export default LocksPanel;
